// extracted by mini-css-extract-plugin
export var container = "_dp-0";
export var infoIcon = "_dp-2";
export var internalLabel = "_dp-3";
export var titleRowCol = "_dp-1";